import { render } from "./App.vue?vue&type=template&id=467fbeac"
const script = {}

import "./App.vue?vue&type=style&index=0&id=467fbeac&lang=scss"

import exportComponent from "/home/sentry/temp/sensoren/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__